import ProductSearchComponent from '../base/productSearchComponent';
export default class Sorting extends ProductSearchComponent {
    constructor(element) {
        super(element);
        this.refinementsCount = 0;
        this.endpoint = document.body.querySelector(this.selectors.productListWrapper).getAttribute('data-endpoint').split('?')[0] || '';
        this.listenForChanges();
    }
    get SELECTORS() {
        return {
            productListWrapper: '.product-grid',
            selectableItems: '.sorting--input'
        };
    }
    listenForChanges() {
        const sortingInputs = [...this._el.querySelectorAll(this.SELECTORS.selectableItems)];
        sortingInputs.forEach((trigger) => {
            trigger.addEventListener('change', async (e) => {
                this.printMethod = 'replace';
                window.productSearchData.searchParams.start = 0;
                window.productSearchData.searchParams.sz = window.productSearchData.increment;
                window.productSearchData.searchParams.srule = e.currentTarget.getAttribute('value') || '';
                this.getPage(e.currentTarget);
            });
        });
    }
    updateData() {
        window.productSearchData.currentPage = 1;
        window.productSearchData.counter = window.productSearchData.increment;
        window.productSearchData.datalayerOffset = 1;
        let excludedKeys = ['cgid', 'start'];
        let sortingKeys = Object.assign({}, window.productSearchData.searchParams);
        excludedKeys.forEach((key) => {
            delete sortingKeys[key];
        });
        window.productSearchData.searchQs = sortingKeys;
    }
}
